import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { ASCIIService } from './api/aSCII.service';
import { BattleFieldService } from './api/battleField.service';
import { BoardService } from './api/board.service';
import { CivilizationBoardService } from './api/civilizationBoard.service';
import { EngineBattleService } from './api/engineBattle.service';
import { EngineCityManagementService } from './api/engineCityManagement.service';
import { EngineCommonsService } from './api/engineCommons.service';
import { EngineMovementService } from './api/engineMovement.service';
import { EngineResearchService } from './api/engineResearch.service';
import { EngineStartOfTurnService } from './api/engineStartOfTurn.service';
import { EngineTradeService } from './api/engineTrade.service';
import { GameService } from './api/game.service';
import { MapService } from './api/map.service';
import { MarketService } from './api/market.service';
import { RulesService } from './api/rules.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    ASCIIService,
    BattleFieldService,
    BoardService,
    CivilizationBoardService,
    EngineBattleService,
    EngineCityManagementService,
    EngineCommonsService,
    EngineMovementService,
    EngineResearchService,
    EngineStartOfTurnService,
    EngineTradeService,
    GameService,
    MapService,
    MarketService,
    RulesService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
